var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corporateCultureBox"},[_c('aboutBannerVue',{attrs:{"tabIndex":"6"}}),_c('div',{staticClass:"mapShow",staticStyle:{"width":"1200px","height":"735px"},attrs:{"id":"main"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }